import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import "./css/styles.css";

import 'bootstrap/dist/css/bootstrap.min.css';
import './libsExt/fontAwesomeConfig'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
